/**************************************************
 * Nombre:       Boton_Icono
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {irUrl} from "../../../../Utilidades/irUrl";
import {useResponsive} from "../../../../Modulo_Responsive/Hooks/useResponsive";

const Boton_Icono = ({item, gradiente = false}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            onClick={() => irUrl(item.url)}
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                background: gradiente ? 'linear-gradient(90deg,rgba(122, 28, 255, 1) 0%, rgba(124, 240, 255, 1) 100%)' : '#ffffff50',
                p: 1,
                borderRadius: 6,
                minHeight: 44,
                cursor: 'pointer',

            }}
        >

            <Grid container size={{xs: 1, sm: 1, md: 1}} sx={{justifyContent: 'flex-start', pl: 0}}>
                <img src={item.img} width={sCell ? 28 : 32} height={'auto'}/>
            </Grid>


            <Grid container size={{xs: 11, sm: 11, md: 11}} sx={{justifyContent: 'center'}}>
                <Typography sx={{textAlign: 'center', pl: 0, fontSize: 14, fontWeight: 500}}>{item.nombre}</Typography>
            </Grid>

        </Grid>
    )

}
export default Boton_Icono